import { render } from "./MemorialSlideGroup.vue?vue&type=template&id=2897a0c3"
import script from "./MemorialSlideGroup.vue?vue&type=script&lang=js"
export * from "./MemorialSlideGroup.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__